import { getEntitiesByFpIdOptions } from '@onefootprint/fetch-dashboard';
import { useQuery } from '@tanstack/react-query';

export const useEntity = (id: string) => {
  return useQuery({
    ...getEntitiesByFpIdOptions({
      path: { fpId: id },
    }),
    enabled: !!id,
  });
};

export default useEntity;
